<template>
  <div class="table-row" v-on:click="showChildren = !showChildren">
    <div class="row">
      <div class="col-2">
        <template v-if="problem.Meetings.length > 0"><span v-if="showChildren">▼</span>
        <span v-else>►</span></template>
        {{ problem.name }}
      </div>
      <div class="col-1">{{ problem.loss }}</div>
      <div class="col-1" v-if="$parent.kpiData.kpi_unit_financial > 0">{{ problem.loss_money }}</div>
      <div class="col-1">{{ problem.loss_percentage }}</div>
      <div class="col-1">{{ problem.frequency }}</div>
      <div class="col-2">{{ problem.Meetings.length }} {{ $t("sessions") }}</div>
      <div class="col-1">{{ problem.Actions.length}}</div>
      <div class="col-1">{{ problem.covered }} %</div>
      <div class="col-2">
        <router-link :to="'/planmeeting?problem=' + problem.uid + '&kpiId=' + $parent.kpiData.uid" data-toggle="modal" :data-target="'#' + modalId">{{ $t("Plan session") }}</router-link>
      </div>
    </div>
    <div v-show="showChildren" class="row meeting-row" v-for="meeting in problem.Meetings">
      <div class="col-6">
        {{ meeting.MeetingNorm.name }} <span class="text-grey">{{ $t(meeting.MeetingNorm.meeting_type) }}</span>
      </div>
      <div class="col-4"></div>
      <div class="col-2" v-html="$options.filters.formatDateDay(meeting.date_start, this)"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ProblemTableRow",
    props:['problem', 'modalId'],
    data: function () {
      return {
        showChildren: false
      }
    }
  }
</script>

<style scoped>
  .text-grey{
    color: #64728c;
  }
  .meeting-row{
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProblemTableRow.vue